export const commonEnvironment = {
  dpcmRedirectionFlag: 'cp-20128-discrete-and-power-cost-sme-model'
}
